import { FileModel, ToastDuration, ToastService, listToDictionary } from '@shared';
import { IImportHandler } from '../import-handler.interface';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { TranslateService } from '@ngx-translate/core';

export class DataAndStructureValidator implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private toastService: ToastService,
		private translateService: TranslateService
	) {}

	public async handle(model: FileModel): Promise<void> {
		console.log("Model222: ", model);
		
		if (model.TABLE_DATA.length == 0) {
			if (this.next) {
				await this.next.handle(model);
			}
			return
		}
		const dataByTable = listToDictionary(
			WorkspaceDatabaseKeys.tables.tableName,
			model.TABLE_DATA,
			null,
			(key: string) => (key ? key.toLowerCase() : key)
		);
		const tablesDictionary = listToDictionary(
			WorkspaceDatabaseKeys.tables.tableName,
			model.FusionDataTables,
			null,
			(key: string) => (key ? key.toLowerCase() : key)
		);

		for (const key in dataByTable) {
			if (WorkspaceDatabaseKeys.excludedItems.map((excludedItem) => excludedItem.toLowerCase()).includes(key)) {
				continue;
			}

			if (tablesDictionary[key] === undefined) {
				this.toastService.presentError(
					this.translateService.instant('alert.import.validationMessages.dataAndStructure', { table: key }),
					ToastDuration.Slow
				);

				throw Error('There is no matching table for ' + key);
			}
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}
}
